<template>
  <object
    type="image/svg+xml"
    :data="logoPath"
    v-if="icon"
    :alt="`${icon} icon`"
  >
    hireful.
  </object>
</template>

<script>
export default {
  name: 'hireful-icon',
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    logoPath () {
      return this.icon ? require(`@/assets/icons/${this.icon}.svg`) : ''
    }
  }
}
</script>

<style>

</style>
